/* unplugin-vue-components disabled */import __unplugin_components_0 from 'E:/new-admin/3.0/ruoyi-vue3-cli/src/components/Pagination/index.vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, isRef as _isRef, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ae1f8b98"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dialog-footer"
}, null, -1));
const _hoisted_2 = {
  class: "dialog-footer"
};
import Purchaserecord from "./Purchaserecord";
import { queryVersionPayDetailPage, queryVersionPayDetailByCode, updateServerEndTime } from "@/api/charge";
export default {
  __name: 'Chargedetails',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const loading = ref(false);
    const total = ref(0);
    const dialogFormVisible = ref(false);
    const value = ref({});
    const title = ref('购买记录');
    const size = ref('default');
    const componentName = Purchaserecord;
    const deadlineDateVisible = ref(false);
    const deadlineDateFormRef = ref();
    const data = reactive({
      tableData: [{}],
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      deadlineDateForm: {},
      deadlineDateFormRules: {
        serverEndTime: [{
          required: true,
          message: '截止日期不能为空',
          trigger: 'blur'
        }]
      }
    });
    const {
      tableData,
      queryParams,
      deadlineDateForm,
      deadlineDateFormRules,
      list
    } = toRefs(data);
    const resetForm = formEl => {
      if (!formEl) return;
      formEl.resetFields();
      deadlineDateVisible.value = false;
    };

    // 查看购买记录
    const buyRecord = async row => {
      const {
        data
      } = await getBuyRecord(row);
      list.value = [data];
      dialogFormVisible.value = true;
    };

    // 获取购买记录
    const getBuyRecord = row => {
      const {
        code
      } = row;
      return queryVersionPayDetailByCode({
        code
      });
    };

    // 调整截止日期
    const deadlineDate = row => {
      title.value = '截止日期';
      const {
        serverEndTime,
        code
      } = row;
      deadlineDateForm.value.serverEndTime = serverEndTime;
      deadlineDateForm.value.code = code;
      deadlineDateVisible.value = true;
    };

    // 关闭购买记录弹窗
    const closeDialog = () => {
      dialogFormVisible.value = false;
    };
    const handleClose = () => {};
    const reset = () => {
      deadlineDateForm.value = {
        serverEndTime: null,
        code: null
      };
      proxy.resetForm('deadlineDateFormRef');
    };
    // 调整截止日期确定
    const submitForm = async formEl => {
      if (!formEl) return;
      await formEl.validate((valid, fileds) => {
        if (valid) {
          console.log(deadlineDateForm.value);
          edit();
          console.log('submit');
        } else {
          console.log('error submit');
        }
      });
    };
    const edit = () => {
      updateServerEndTime(deadlineDateForm.value).then(res => {
        deadlineDateVisible.value = false;
        proxy.$modal.msgSuccess("修改成功");
        getList();
      });
    };

    // 查询收费明细
    const getList = () => {
      queryVersionPayDetailPage(queryParams.value).then(res => {
        tableData.value = res.data;
        total.value = res.total;
      });
    };
    const closeDeadlineDateDialog = () => {
      deadlineDateVisible.value = false;
      reset();
    };
    getList();
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table = _resolveComponent("el-table");
      const _component_pagination = __unplugin_components_0;
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        "max-height": 650,
        data: _unref(tableData),
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "id",
          label: "id",
          width: ""
        }), _createVNode(_component_el_table_column, {
          prop: "shopName",
          label: "商家名称",
          width: ""
        }), _createVNode(_component_el_table_column, {
          prop: "versionNo",
          label: "当前版本",
          width: ""
        }), _createVNode(_component_el_table_column, {
          prop: "serverEndTime",
          label: "服务截止日期",
          width: ""
        }), _createVNode(_component_el_table_column, {
          fixed: "right",
          label: "操作",
          width: "120"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            class: "operation",
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => buyRecord(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("购买记录")]),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => deadlineDate(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("截止日期")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])), [[_directive_loading, _unref(loading)]]), _withDirectives(_createVNode(_component_pagination, {
        total: _unref(total),
        page: _unref(queryParams).pageNum,
        "onUpdate:page": _cache[0] || (_cache[0] = $event => _unref(queryParams).pageNum = $event),
        limit: _unref(queryParams).pageSize,
        "onUpdate:limit": _cache[1] || (_cache[1] = $event => _unref(queryParams).pageSize = $event),
        onPagination: getList
      }, null, 8, ["total", "page", "limit"]), [[_vShow, _unref(total) > 0]]), _createVNode(_component_el_dialog, {
        width: "60%",
        modelValue: _unref(dialogFormVisible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(dialogFormVisible) ? dialogFormVisible.value = $event : null),
        "before-close": closeDialog,
        title: _unref(title)
      }, {
        footer: _withCtx(() => [_hoisted_1]),
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(componentName)), {
          list: _unref(list),
          onHandleClose: handleClose
        }, null, 40, ["list"]))]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_el_dialog, {
        width: "30%",
        modelValue: _unref(deadlineDateVisible),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(deadlineDateVisible) ? deadlineDateVisible.value = $event : null),
        "before-close": closeDeadlineDateDialog,
        title: _unref(title)
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => resetForm(_unref(deadlineDateFormRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = $event => submitForm(_unref(deadlineDateFormRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("提交")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "deadlineDateFormRef",
          ref: deadlineDateFormRef,
          model: _unref(deadlineDateForm),
          rules: _unref(deadlineDateFormRules),
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "截止日期",
            prop: "serverEndTime"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_date_picker, {
              modelValue: _unref(deadlineDateForm).serverEndTime,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(deadlineDateForm).serverEndTime = $event),
              type: "datetime",
              "value-format": "YYYY-MM-DD HH:mm:ss",
              placeholder: "请选择截止日期",
              size: _unref(size)
            }, null, 8, ["modelValue", "size"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};